import { Icon, LoadingLottie, ospThemes } from "@ospweb/sdk-ui";
import React from "react";
import { cn } from "utils";

interface SwapSkeletonProps {
  onExitClick?: () => void;
  className?: string;
  style?: React.CSSProperties;
  iframeWidth: number;
}

function dp2Vw(dp: number, iframeWidth: number): number {
  const dpr = (dp / 480) * iframeWidth;
  return dpr;
}

export default function SwapSkeleton({
  onExitClick,
  className,
  style,
  iframeWidth,
}: SwapSkeletonProps) {
  const dpOf20 = dp2Vw(20, iframeWidth);

  return (
    <div
      style={{ padding: dpOf20, paddingLeft: dpOf20, ...style }}
      className={cn(
        "flex rounded-2xl relative mx-auto flex-col justify-between bg-background_solid_tertiary",
        className,
      )}
    >
      <div className="flex flex-col w-full h-full">
        <div className="flex items-center justify-between">
          <span
            className="headline_regular_m text-content_primary"
            style={{ fontSize: dpOf20 }}
          ></span>
          <button
            aria-label="Swap Skeleton"
            data-openreplay-label="misc_swapskeleton_click"
            id="btn-swap-skeleton"
            onClick={onExitClick}
          >
            <div className="p-2">
              <Icon
                name="close"
                size={dp2Vw(15, iframeWidth)}
                color={ospThemes.colors.content_tertiary}
              />
            </div>
          </button>
        </div>
        <div className="flex items-center justify-center w-full h-full">
          <LoadingLottie
            style={{
              width: 80,
              height: 80,
            }}
          />
        </div>
      </div>
    </div>
  );
}
